import styled from "styled-components";
import "../../styles/variables.css";

export const ScoreLoaderContainer = styled.div`
  width: 100%;
  text-align: center;
  @media (max-width: 600px) {
    height: 100%;
    display: flex;
    align-items: center;
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: 2px;
  margin: 30px 0 50px 0;
  border-top: 1px solid var(--border-light);
`;
